import type { DonationsQueryParams } from "../../types.ts";

// Query keys for React Query - donations verification
export const donationsVerificationKeys = {
  all: ["verification-donations"] as const,
  unassignedStages: (params: DonationsQueryParams) =>
    [...donationsVerificationKeys.all, "unassignedStages", params] as const,
};
